import React from "react";

const About = () => {
  const strengths = [
    {
      title: "Frontend Application Development",
      desc: "Designing and building responsive React and Next.js interfaces with TypeScript, Material UI, shadcn/ui, Tailwind CSS, reusable UI patterns, and dashboard workflows.",
    },
    {
      title: "Integration & State Management",
      desc: "Connecting frontend workflows to REST and gRPC-backed services through BFF layers, React Query, Jotai, i18n, Elasticsearch features, and tested UI paths.",
    },
    {
      title: "Product Delivery",
      desc: "Contributing beyond implementation through CMS setup, SEO foundations, analytics, lead management, WhatsApp automation, and business-oriented feature planning.",
    },
  ];

  const highlights = [
    "Delivered payroll management and configuration workflows for Runa HR",
    "Built College Cosmos with CMS-backed content, SEO foundations, analytics, and lead-generation workflows",
    "Recorded 15.6K Search Console impressions, 131 clicks, and an average position of 9 over a recent 28-day period for College Cosmos",
    "Developing Glamnexx SaaS workflows for WhatsApp automation, templates, AI assistant flows, and customer engagement",
    "Completed Meta Tech Provider access verification for Glamnexx business-asset onboarding and integration flows",
    "Implemented CRM map workflows using Leaflet, geofencing, and route drawing",
  ];

  return (
    <section
      name="about"
      className="bg-[#0b0f12] px-5 py-24 text-white lg:px-8"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-[0.82fr_1.18fr]">
          <div>
            <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-emerald-300">
              Capabilities
            </p>
            <h2 className="mt-4 text-3xl font-extrabold leading-tight sm:text-5xl">
              Engineering work focused on reliable interfaces, integrations,
              and product outcomes.
            </h2>
            <p className="mt-6 text-lg leading-8 text-zinc-400">
              I work across frontend application development, API integration,
              and product delivery. My focus is building maintainable React
              patterns, clear workflows, and interfaces that support real
              operational use cases.
            </p>
          </div>

          <div className="grid gap-5 md:grid-cols-3">
            {strengths.map(({ title, desc }) => (
              <article
                key={title}
                className="rounded-md border border-white/10 bg-white/[0.04] p-6"
              >
                <h3 className="text-xl font-extrabold text-white">
                  {title}
                </h3>
                <p className="mt-4 leading-7 text-zinc-400">{desc}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-12 rounded-md border border-emerald-400/20 bg-[#111719] p-6 text-white">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-emerald-300">
            Practical Scope
          </p>
          <div className="mt-5 grid gap-4 md:grid-cols-2">
            {highlights.map((highlight) => (
              <div key={highlight} className="flex gap-3">
                <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-emerald-300" />
                <p className="leading-7 text-zinc-300">{highlight}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
